"use client";

import { cn } from "@/lib/utils";

import { MockupAccentStreaks } from "./MockupAccentStreaks";
import {
  MOCKUP_BENTO_CANVAS_WIDTH,
  MOCKUP_BENTO_SCALE,
  mockupSizeClasses,
} from "./MockupScene.constants";
import type { ScaledSlideProps } from "./MockupScene.types";

export const ScaledSlide = ({
  size = "bento",
  className,
  children,
}: ScaledSlideProps) => {
  if (size === "fill") {
    return (
      <div
        className={cn(
          "relative h-full min-h-0 w-full overflow-hidden",
          className,
        )}
      >
        {children}
      </div>
    );
  }

  if (size === "bento") {
    return (
      <div
        className={cn(
          "relative w-full overflow-hidden rounded-xl border border-zinc-200/50 bg-zinc-50 shadow-[0_16px_48px_-28px_rgba(0,0,0,0.1)] dark:border-white/[0.06] dark:bg-[#0c0d10] dark:shadow-[0_16px_48px_-28px_rgba(0,0,0,0.75)]",
          mockupSizeClasses.bento,
          className,
        )}
      >
        <MockupAccentStreaks />
        <div
          className="pointer-events-none absolute left-1/2 top-0"
          style={{
            width: MOCKUP_BENTO_CANVAS_WIDTH,
            transform: `translateX(-50%) scale(${MOCKUP_BENTO_SCALE})`,
            transformOrigin: "top center",
          }}
        >
          {children}
        </div>
      </div>
    );
  }

  return (
    <div
      className={cn(
        "relative w-full overflow-hidden rounded-xl",
        mockupSizeClasses[size],
        className,
      )}
    >
      {children}
    </div>
  );
};
